module.exports = __webpack_public_path__ + "img/banner.b827a0f4.png";